import React from 'react';
import { Button } from '@/shared/ui/button';

export default function TimeFilterSelect({ options, value, onChange, totalUsage }) {
  return (
    <div className="flex items-center justify-between mt-2">
      <div className="flex gap-1 bg-[var(--surface-raised)] p-1 rounded-lg">
        {options.map((option) => (
          <Button
            key={option.id}
            variant={value === option.id ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onChange(option.id)}
            className={value === option.id ? 'bg-[var(--success)] hover:bg-[var(--success)] text-[var(--on-primary)]' : 'text-[var(--text-secondary)] hover:text-[var(--text-primary)]'}
          >
            {option.label}
          </Button>
        ))}
      </div>
      <div className="text-sm text-[var(--text-secondary)]">
        Totale periodo: <span className="font-semibold text-[var(--text-primary)]">{totalUsage} utilizzi</span>
      </div>
    </div>
  );
}
